<template>
  <!-- <div class="menu-bar" v-show="curMenu > 0"> -->
  <!-- 左侧导航 start -->
  <div v-show="curMenu > 0" class="side-menu">
    <div class="side-content">
      <div class="side-box">
        <div class="side-line"></div>
        <ul class="side-bar">
          <li
            v-for="(menu, idx) in menuList"
            :key="menu.enName"
            :class="{ active: curMenu - 1 === idx }"
            @click="moveFullTo(idx + 2)"
          >
            <a>
              <strong>{{ menu.name }}</strong>
              <strong>{{ menu.enName }}</strong>
            </a>
          </li>
          <li>
            <a @click="goTop"><strong>回到顶部</strong><strong>TOP</strong></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!--左侧导航 end -->
  <!-- </div> -->
</template>

<script>
import { mapState } from "vuex";
import utils from "@/libs/utils";
const _hmt = window._hmt;
export default {
  name: "MenuBar",
  data: () => ({
    menuList: [
      { name: "阿多拉资讯", enName: "NEWS" },
      { name: "故事", enName: "STORY" },
      { name: "角色情报", enName: "CHARACTER" },
      { name: "影音鉴赏", enName: "VIDEO&MUSIC" },
      { name: "联系我们", enName: "ABOUT US" }
    ]
  }),
  computed: {
    ...mapState(["curPage"]),
    curMenu() {
      return this.curPage < 6 ? this.curPage : -1;
    }
  },
  methods: {
    moveFullTo(idx) {
      this.$emit("moveTo", idx);
    },
    goTop() {
      _hmt.push(["_trackEvent", "pinBtns", "goTop", utils.checkOperaSys()]);
      this.$emit("moveTo", 1);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/mixin.less";

.side-menu {
  position: fixed;
  top: 345px;
  right: 0;
  z-index: 1;
  width: 140px;
  height: 357px;
  .side-wx-box {
    margin-bottom: 35px;
    p {
      margin: 0;
      font-size: 11px;
      color: #b6b6b6;
      text-align: center;
      letter-spacing: -1px;
    }
  }
  .side-wx {
    display: inline-block;
    padding: 2px;
    border: solid 2px #565656;
  }
  .side-wx-pic {
    width: 102px;
    height: 102px;
    vertical-align: middle;
  }
  .side-bar {
    width: 140px;
    height: auto;
    padding-top: 7px;
    overflow: hidden;
    font-family: SourceHanSerifCNSemiBold;
    border: 1px solid transparent;
    transition: all 0.3s;
  }
  .side-line {
    position: absolute;
    top: 13px;
    left: 0;
    width: 13px;
    height: 302px;
    background: url("~@/assets/images/menu-line.png") no-repeat center;
  }
  li {
    position: relative;
    width: 140px;
    height: 38px;
    margin-bottom: 20px;
    line-height: 0;
    cursor: pointer;
    a {
      display: inline-block;
      margin-left: 22px;
      color: #bfc2c7;
      -webkit-transform-origin: 0 100%;
      -moz-transform-origin: 0 100%;
      -ms-transform-origin: 0 100%;
      -o-transform-origin: 0 100%;
      transform-origin: 0 100%;
      .transition(0.3s);
    }
    &:hover {
      a {
        .transform(scale(1.1));

        color: #fefefe;
      }
    }
    &.active::before {
      position: absolute;
      top: 6px;
      left: 0;
      display: block;
      width: 13px;
      max-width: 455px;
      height: 13px;
      content: "";
      background: url("~@/assets/images/mbh.png") no-repeat 0 0;
      opacity: 1;
    }
    &:first-child {
      &.active::before {
        position: absolute;
        top: 6px;
        left: 0;
      }
    }
    &:nth-child(3) {
      &.active::before {
        position: absolute;
        top: 6px;
        left: 0;
      }
    }
    &:nth-child(4) {
      &.active::before {
        position: absolute;
        left: 0;
      }
    }
    &:nth-child(5) {
      &.active::before {
        position: absolute;
        top: 11px;
        left: 0;
      }
    }

    strong {
      display: block;
      font-family: "SourceHanSerifCN-SemiBold";
      line-height: 1;
      letter-spacing: 2px;
      letter-spacing: -0.005rem;
      &:first-child {
        font-size: 18px;
      }
      &:last-child {
        margin-top: 4px;
        font-size: 10px;
      }
    }
  }
}
</style>
